import { HttpHelper } from '../helpers/httpHelper';
import { UrlManager } from '../providers/urlManager/urlManager';

export const reviewApi = {
    submitReviewRequest: data => {
        return HttpHelper.fetch(UrlManager.getReviewRequestUrl(), {
            method: 'POST',
            body: data,
        });
    },

    updateReviewStatus: data => {
        return HttpHelper.fetch(UrlManager.getUpdateReviewStatusUrl(), {
            method: 'POST',
            body: data,
        });
    },
};
